<div class="share1" fxLayout="row" fxLayoutAlign="start center">
    <span>Sort By</span>
  </div>
  <div class="content p-B15" fxLayout="column" fxLayoutGap="20px">
  
    <mat-radio-group  class="content1" >
      <mat-radio-button color="primary" (change)="radioChange(sort)" [checked]="sort.viewValue==productSort " class="radio"
       *ngFor="let sort of sortings" [value]="sort.viewValue">
        {{sort.viewValue}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <!-- <mat-divider></mat-divider>
  <div fxLayout="row">
    <div fxFlex="50" (click)="close()" matRipple class="cancel" fxLayout="row" fxLayoutAlign="center center">
      <span>Cancel</span>
    </div>
    <div fxFlex="50"  class="faliure-bg padding-10" (click)="close()" matRipple class="cancel" fxLayout="row" fxLayoutAlign="center center">
      <span>Apply</span>
    </div>
  </div> -->
  
